export enum Mode {
    WRITE,
    EDIT
}
